export default __webpack_public_path__ + "static/media/optionBox.53916280.svg";